<script>
// @ts-check

import BaseButton from '@/components/base/BaseButton.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'BottomNavDropdownItem',
  components: {
    BaseButton
  },
  props: {
    name: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },
  emits: ['showNoBankAccountErrorDialog'],
  data() {
    return {
      isNavigating: false
    }
  },
  computed: {
    ...mapGetters('app', ['isTlpService', 'isOyService']),
    ...mapGetters('companyData', [
      'hasBankAccount',
      'isInDemoMode',
      'companyIsActive',
      'wizardCompleted'
    ]),
    isBankAccountRequired() {
      // for TLP service the bank account is always required
      if (this.isTlpService) {
        return true
      }

      // for other services the bank account is required only for invoices
      return this.name === 'new_invoice'
    },
    isDisabled() {
      const isActive = !this.companyIsActive

      if (this.isOyService) {
        return !this.wizardCompleted || isActive
      }

      return isActive
    }
  },
  methods: {
    async createNewEntry() {
      if (
        !this.isInDemoMode &&
        this.isBankAccountRequired &&
        !this.hasBankAccount
      ) {
        this.$emit('showNoBankAccountErrorDialog')
        return
      }

      this.isNavigating = true

      await this.$router.push({ name: this.name })

      this.isNavigating = false
    }
  }
}
</script>

<template>
  <div class="bottom-nav_dropdown-item">
    <BaseButton
      class="bottom-nav_dropdown-item-button"
      :loading="isNavigating"
      filled
      @click="createNewEntry"
    >
      <VIcon
        :icon
        size="1.5rem"
        class="mr-2"
        :class="{
          '-mt-0.5': icon !== '$invoice-text-outline'
        }"
      />
      {{ label }}
    </BaseButton>
  </div>
</template>
